import { createIcon } from '../../icon';

import AppsXSmallIconSvg from './apps-xsmall.svg';
import AppsXSmallBoldIconSvg from './apps-xsmall-bold.svg';
import AppsSmallIconSvg from './apps-small.svg';
import AppsSmallBoldIconSvg from './apps-small-bold.svg';
import AppsMediumIconSvg from './apps-medium.svg';
import AppsMediumBoldIconSvg from './apps-medium-bold.svg';
import AppsLargeIconSvg from './apps-large.svg';
import AppsLargeBoldIconSvg from './apps-large-bold.svg';
import DecodoLogoXSmallIconSvg from './decodo-logo-xsmall.svg';
import DecodoLogoXSmallBoldIconSvg from './decodo-logo-xsmall-bold.svg';
import DecodoLogoSmallIconSvg from './decodo-logo-small.svg';
import DecodoLogoSmallBoldIconSvg from './decodo-logo-small-bold.svg';
import DecodoLogoMediumIconSvg from './decodo-logo-medium.svg';
import DecodoLogoMediumBoldIconSvg from './decodo-logo-medium-bold.svg';
import DecodoLogoLargeIconSvg from './decodo-logo-large.svg';
import DecodoLogoLargeBoldIconSvg from './decodo-logo-large-bold.svg';
import ResidentialXSmallIconSvg from './residential-xsmall.svg';
import ResidentialXSmallBoldIconSvg from './residential-xsmall-bold.svg';
import ResidentialSmallIconSvg from './residential-small.svg';
import ResidentialSmallBoldIconSvg from './residential-small-bold.svg';
import ResidentialMediumIconSvg from './residential-medium.svg';
import ResidentialMediumBoldIconSvg from './residential-medium-bold.svg';
import ResidentialLargeIconSvg from './residential-large.svg';
import ResidentialLargeBoldIconSvg from './residential-large-bold.svg';
import DataCenterXSmallIconSvg from './data-center-xsmall.svg';
import DataCenterXSmallBoldIconSvg from './data-center-xsmall-bold.svg';
import DataCenterSmallIconSvg from './data-center-small.svg';
import DataCenterSmallBoldIconSvg from './data-center-small-bold.svg';
import DataCenterMediumIconSvg from './data-center-medium.svg';
import DataCenterMediumBoldIconSvg from './data-center-medium-bold.svg';
import DataCenterLargeIconSvg from './data-center-large.svg';
import DataCenterLargeBoldIconSvg from './data-center-large-bold.svg';
import MobileXSmallIconSvg from './mobile-xsmall.svg';
import MobileXSmallBoldIconSvg from './mobile-xsmall-bold.svg';
import MobileSmallIconSvg from './mobile-small.svg';
import MobileSmallBoldIconSvg from './mobile-small-bold.svg';
import MobileMediumIconSvg from './mobile-medium.svg';
import MobileMediumBoldIconSvg from './mobile-medium-bold.svg';
import MobileLargeIconSvg from './mobile-large.svg';
import MobileLargeBoldIconSvg from './mobile-large-bold.svg';
import SocialMediaXSmallIconSvg from './social-media-xsmall.svg';
import SocialMediaXSmallBoldIconSvg from './social-media-xsmall-bold.svg';
import SocialMediaSmallIconSvg from './social-media-small.svg';
import SocialMediaSmallBoldIconSvg from './social-media-small-bold.svg';
import SocialMediaMediumIconSvg from './social-media-medium.svg';
import SocialMediaMediumBoldIconSvg from './social-media-medium-bold.svg';
import SocialMediaLargeIconSvg from './social-media-large.svg';
import SocialMediaLargeBoldIconSvg from './social-media-large-bold.svg';
import ISPXSmallIconSvg from './isp-xsmall.svg';
import ISPXSmallBoldIconSvg from './isp-xsmall-bold.svg';
import ISPSmallIconSvg from './isp-small.svg';
import ISPSmallBoldIconSvg from './isp-small-bold.svg';
import ISPMediumIconSvg from './isp-medium.svg';
import ISPMediumBoldIconSvg from './isp-medium-bold.svg';
import ISPLargeIconSvg from './isp-large.svg';
import ISPLargeBoldIconSvg from './isp-large-bold.svg';
import ExtensionXSmallIconSvg from './extension-xsmall.svg';
import ExtensionXSmallBoldIconSvg from './extension-xsmall-bold.svg';
import ExtensionSmallIconSvg from './extension-small.svg';
import ExtensionSmallBoldIconSvg from './extension-small-bold.svg';
import ExtensionMediumIconSvg from './extension-medium.svg';
import ExtensionMediumBoldIconSvg from './extension-medium-bold.svg';
import ExtensionLargeIconSvg from './extension-large.svg';
import ExtensionLargeBoldIconSvg from './extension-large-bold.svg';
import XBrowserXSmallIconSvg from './xbrowser-xsmall.svg';
import XBrowserXSmallBoldIconSvg from './xbrowser-xsmall-bold.svg';
import XBrowserSmallIconSvg from './xbrowser-small.svg';
import XBrowserSmallBoldIconSvg from './xbrowser-small-bold.svg';
import XBrowserMediumIconSvg from './xbrowser-medium.svg';
import XBrowserMediumBoldIconSvg from './xbrowser-medium-bold.svg';
import XBrowserLargeIconSvg from './xbrowser-large.svg';
import XBrowserLargeBoldIconSvg from './xbrowser-large-bold.svg';
import ProxyCheckerXSmallIconSvg from './proxy-checker-xsmall.svg';
import ProxyCheckerXSmallBoldIconSvg from './proxy-checker-xsmall-bold.svg';
import ProxyCheckerSmallIconSvg from './proxy-checker-small.svg';
import ProxyCheckerSmallBoldIconSvg from './proxy-checker-small-bold.svg';
import ProxyCheckerMediumIconSvg from './proxy-checker-medium.svg';
import ProxyCheckerMediumBoldIconSvg from './proxy-checker-medium-bold.svg';
import ProxyCheckerLargeIconSvg from './proxy-checker-large.svg';
import ProxyCheckerLargeBoldIconSvg from './proxy-checker-large-bold.svg';
import ECommerceXSmallIconSvg from './ecommerce-xsmall.svg';
import ECommerceXSmallBoldIconSvg from './ecommerce-xsmall-bold.svg';
import ECommerceSmallIconSvg from './ecommerce-small.svg';
import ECommerceSmallBoldIconSvg from './ecommerce-small-bold.svg';
import ECommerceMediumIconSvg from './ecommerce-medium.svg';
import ECommerceMediumBoldIconSvg from './ecommerce-medium-bold.svg';
import ECommerceLargeIconSvg from './ecommerce-large.svg';
import ECommerceLargeBoldIconSvg from './ecommerce-large-bold.svg';
import SiteUnblockerXSmallIconSvg from './site-unblocker-xsmall.svg';
import SiteUnblockerXSmallBoldIconSvg from './site-unblocker-xsmall-bold.svg';
import SiteUnblockerSmallIconSvg from './site-unblocker-small.svg';
import SiteUnblockerSmallBoldIconSvg from './site-unblocker-small-bold.svg';
import SiteUnblockerMediumIconSvg from './site-unblocker-medium.svg';
import SiteUnblockerMediumBoldIconSvg from './site-unblocker-medium-bold.svg';
import SiteUnblockerLargeIconSvg from './site-unblocker-large.svg';
import SiteUnblockerLargeBoldIconSvg from './site-unblocker-large-bold.svg';
import SERPXSmallIconSvg from './serp-xsmall.svg';
import SERPXSmallBoldIconSvg from './serp-xsmall-bold.svg';
import SERPSmallIconSvg from './serp-small.svg';
import SERPSmallBoldIconSvg from './serp-small-bold.svg';
import SERPMediumIconSvg from './serp-medium.svg';
import SERPMediumBoldIconSvg from './serp-medium-bold.svg';
import SERPLargeIconSvg from './serp-large.svg';
import SERPLargeBoldIconSvg from './serp-large-bold.svg';
import ScrapersXSmallIconSvg from './scrapers-xsmall.svg';
import ScrapersXSmallBoldIconSvg from './scrapers-xsmall-bold.svg';
import ScrapersSmallIconSvg from './scrapers-small.svg';
import ScrapersSmallBoldIconSvg from './scrapers-small-bold.svg';
import ScrapersMediumIconSvg from './scrapers-medium.svg';
import ScrapersMediumBoldIconSvg from './scrapers-medium-bold.svg';
import ScrapersLargeIconSvg from './scrapers-large.svg';
import ScrapersLargeBoldIconSvg from './scrapers-large-bold.svg';
import ProxiesXSmallIconSvg from './proxies-xsmall.svg';
import ProxiesXSmallBoldIconSvg from './proxies-xsmall-bold.svg';
import ProxiesSmallIconSvg from './proxies-small.svg';
import ProxiesSmallBoldIconSvg from './proxies-small-bold.svg';
import ProxiesMediumIconSvg from './proxies-medium.svg';
import ProxiesMediumBoldIconSvg from './proxies-medium-bold.svg';
import ProxiesLargeIconSvg from './proxies-large.svg';
import ProxiesLargeBoldIconSvg from './proxies-large-bold.svg';

export const AppsXSmallIcon = createIcon(
  AppsXSmallIconSvg,
  'AppsXSmallIcon',
  12
);
export const AppsXSmallBoldIcon = createIcon(
  AppsXSmallBoldIconSvg,
  'AppsXSmallBoldIcon',
  12
);
export const AppsSmallIcon = createIcon(AppsSmallIconSvg, 'AppsSmallIcon', 16);
export const AppsSmallBoldIcon = createIcon(
  AppsSmallBoldIconSvg,
  'AppsSmallBoldIcon',
  16
);
export const AppsMediumIcon = createIcon(
  AppsMediumIconSvg,
  'AppsMediumIcon',
  20
);
export const AppsMediumBoldIcon = createIcon(
  AppsMediumBoldIconSvg,
  'AppsMediumBoldIcon',
  20
);
export const AppsLargeIcon = createIcon(AppsLargeIconSvg, 'AppsLargeIcon', 24);
export const AppsLargeBoldIcon = createIcon(
  AppsLargeBoldIconSvg,
  'AppsLargeBoldIcon',
  24
);
export const DecodoLogoXSmallIcon = createIcon(
  DecodoLogoXSmallIconSvg,
  'DecodoLogoXSmallIcon',
  12
);
export const DecodoLogoXSmallBoldIcon = createIcon(
  DecodoLogoXSmallBoldIconSvg,
  'DecodoLogoXSmallBoldIcon',
  12
);
export const DecodoLogoSmallIcon = createIcon(
  DecodoLogoSmallIconSvg,
  'DecodoLogoSmallIcon',
  16
);
export const DecodoLogoSmallBoldIcon = createIcon(
  DecodoLogoSmallBoldIconSvg,
  'DecodoLogoSmallBoldIcon',
  16
);
export const DecodoLogoMediumIcon = createIcon(
  DecodoLogoMediumIconSvg,
  'DecodoLogoMediumIcon',
  20
);
export const DecodoLogoMediumBoldIcon = createIcon(
  DecodoLogoMediumBoldIconSvg,
  'DecodoLogoMediumBoldIcon',
  20
);
export const DecodoLogoLargeIcon = createIcon(
  DecodoLogoLargeIconSvg,
  'DecodoLogoLargeIcon',
  24
);
export const DecodoLogoLargeBoldIcon = createIcon(
  DecodoLogoLargeBoldIconSvg,
  'DecodoLogoLargeBoldIcon',
  24
);
export const ResidentialXSmallIcon = createIcon(
  ResidentialXSmallIconSvg,
  'ResidentialXSmallIcon',
  12
);
export const ResidentialXSmallBoldIcon = createIcon(
  ResidentialXSmallBoldIconSvg,
  'ResidentialXSmallBoldIcon',
  12
);
export const ResidentialSmallIcon = createIcon(
  ResidentialSmallIconSvg,
  'ResidentialSmallIcon',
  16
);
export const ResidentialSmallBoldIcon = createIcon(
  ResidentialSmallBoldIconSvg,
  'ResidentialSmallBoldIcon',
  16
);
export const ResidentialMediumIcon = createIcon(
  ResidentialMediumIconSvg,
  'ResidentialMediumIcon',
  20
);
export const ResidentialMediumBoldIcon = createIcon(
  ResidentialMediumBoldIconSvg,
  'ResidentialMediumBoldIcon',
  20
);
export const ResidentialLargeIcon = createIcon(
  ResidentialLargeIconSvg,
  'ResidentialLargeIcon',
  24
);
export const ResidentialLargeBoldIcon = createIcon(
  ResidentialLargeBoldIconSvg,
  'ResidentialLargeBoldIcon',
  24
);
export const DataCenterXSmallIcon = createIcon(
  DataCenterXSmallIconSvg,
  'DataCenterXSmallIcon',
  12
);
export const DataCenterXSmallBoldIcon = createIcon(
  DataCenterXSmallBoldIconSvg,
  'DataCenterXSmallBoldIcon',
  12
);
export const DataCenterSmallIcon = createIcon(
  DataCenterSmallIconSvg,
  'DataCenterSmallIcon',
  16
);
export const DataCenterSmallBoldIcon = createIcon(
  DataCenterSmallBoldIconSvg,
  'DataCenterSmallBoldIcon',
  16
);
export const DataCenterMediumIcon = createIcon(
  DataCenterMediumIconSvg,
  'DataCenterMediumIcon',
  20
);
export const DataCenterMediumBoldIcon = createIcon(
  DataCenterMediumBoldIconSvg,
  'DataCenterMediumBoldIcon',
  20
);
export const DataCenterLargeIcon = createIcon(
  DataCenterLargeIconSvg,
  'DataCenterLargeIcon',
  24
);
export const DataCenterLargeBoldIcon = createIcon(
  DataCenterLargeBoldIconSvg,
  'DataCenterLargeBoldIcon',
  24
);
export const MobileXSmallIcon = createIcon(
  MobileXSmallIconSvg,
  'MobileXSmallIcon',
  12
);
export const MobileXSmallBoldIcon = createIcon(
  MobileXSmallBoldIconSvg,
  'MobileXSmallBoldIcon',
  12
);
export const MobileSmallIcon = createIcon(
  MobileSmallIconSvg,
  'MobileSmallIcon',
  16
);
export const MobileSmallBoldIcon = createIcon(
  MobileSmallBoldIconSvg,
  'MobileSmallBoldIcon',
  16
);
export const MobileMediumIcon = createIcon(
  MobileMediumIconSvg,
  'MobileMediumIcon',
  20
);
export const MobileMediumBoldIcon = createIcon(
  MobileMediumBoldIconSvg,
  'MobileMediumBoldIcon',
  20
);
export const MobileLargeIcon = createIcon(
  MobileLargeIconSvg,
  'MobileLargeIcon',
  24
);
export const MobileLargeBoldIcon = createIcon(
  MobileLargeBoldIconSvg,
  'MobileLargeBoldIcon',
  24
);
export const SocialMediaXSmallIcon = createIcon(
  SocialMediaXSmallIconSvg,
  'SocialMediaXSmallIcon',
  12
);
export const SocialMediaXSmallBoldIcon = createIcon(
  SocialMediaXSmallBoldIconSvg,
  'SocialMediaXSmallBoldIcon',
  12
);
export const SocialMediaSmallIcon = createIcon(
  SocialMediaSmallIconSvg,
  'SocialMediaSmallIcon',
  16
);
export const SocialMediaSmallBoldIcon = createIcon(
  SocialMediaSmallBoldIconSvg,
  'SocialMediaSmallBoldIcon',
  16
);
export const SocialMediaMediumIcon = createIcon(
  SocialMediaMediumIconSvg,
  'SocialMediaMediumIcon',
  20
);
export const SocialMediaMediumBoldIcon = createIcon(
  SocialMediaMediumBoldIconSvg,
  'SocialMediaMediumBoldIcon',
  20
);
export const SocialMediaLargeIcon = createIcon(
  SocialMediaLargeIconSvg,
  'SocialMediaLargeIcon',
  24
);
export const SocialMediaLargeBoldIcon = createIcon(
  SocialMediaLargeBoldIconSvg,
  'SocialMediaLargeBoldIcon',
  24
);
export const ISPXSmallIcon = createIcon(ISPXSmallIconSvg, 'ISPXSmallIcon', 12);
export const ISPXSmallBoldIcon = createIcon(
  ISPXSmallBoldIconSvg,
  'ISPXSmallBoldIcon',
  12
);
export const ISPSmallIcon = createIcon(ISPSmallIconSvg, 'ISPSmallIcon', 16);
export const ISPSmallBoldIcon = createIcon(
  ISPSmallBoldIconSvg,
  'ISPSmallBoldIcon',
  16
);
export const ISPMediumIcon = createIcon(ISPMediumIconSvg, 'ISPMediumIcon', 20);
export const ISPMediumBoldIcon = createIcon(
  ISPMediumBoldIconSvg,
  'ISPMediumBoldIcon',
  20
);
export const ISPLargeIcon = createIcon(ISPLargeIconSvg, 'ISPLargeIcon', 24);
export const ISPLargeBoldIcon = createIcon(
  ISPLargeBoldIconSvg,
  'ISPLargeBoldIcon',
  24
);
export const ExtensionXSmallIcon = createIcon(
  ExtensionXSmallIconSvg,
  'ExtensionXSmallIcon',
  12
);
export const ExtensionXSmallBoldIcon = createIcon(
  ExtensionXSmallBoldIconSvg,
  'ExtensionXSmallBoldIcon',
  12
);
export const ExtensionSmallIcon = createIcon(
  ExtensionSmallIconSvg,
  'ExtensionSmallIcon',
  16
);
export const ExtensionSmallBoldIcon = createIcon(
  ExtensionSmallBoldIconSvg,
  'ExtensionSmallBoldIcon',
  16
);
export const ExtensionMediumIcon = createIcon(
  ExtensionMediumIconSvg,
  'ExtensionMediumIcon',
  20
);
export const ExtensionMediumBoldIcon = createIcon(
  ExtensionMediumBoldIconSvg,
  'ExtensionMediumBoldIcon',
  20
);
export const ExtensionLargeIcon = createIcon(
  ExtensionLargeIconSvg,
  'ExtensionLargeIcon',
  24
);
export const ExtensionLargeBoldIcon = createIcon(
  ExtensionLargeBoldIconSvg,
  'ExtensionLargeBoldIcon',
  24
);
export const XBrowserXSmallIcon = createIcon(
  XBrowserXSmallIconSvg,
  'XBrowserXSmallIcon',
  12
);
export const XBrowserXSmallBoldIcon = createIcon(
  XBrowserXSmallBoldIconSvg,
  'XBrowserXSmallBoldIcon',
  12
);
export const XBrowserSmallIcon = createIcon(
  XBrowserSmallIconSvg,
  'XBrowserSmallIcon',
  16
);
export const XBrowserSmallBoldIcon = createIcon(
  XBrowserSmallBoldIconSvg,
  'XBrowserSmallBoldIcon',
  16
);
export const XBrowserMediumIcon = createIcon(
  XBrowserMediumIconSvg,
  'XBrowserMediumIcon',
  20
);
export const XBrowserMediumBoldIcon = createIcon(
  XBrowserMediumBoldIconSvg,
  'XBrowserMediumBoldIcon',
  20
);
export const XBrowserLargeIcon = createIcon(
  XBrowserLargeIconSvg,
  'XBrowserLargeIcon',
  24
);
export const XBrowserLargeBoldIcon = createIcon(
  XBrowserLargeBoldIconSvg,
  'XBrowserLargeBoldIcon',
  24
);
export const ProxyCheckerXSmallIcon = createIcon(
  ProxyCheckerXSmallIconSvg,
  'ProxyCheckerXSmallIcon',
  12
);
export const ProxyCheckerXSmallBoldIcon = createIcon(
  ProxyCheckerXSmallBoldIconSvg,
  'ProxyCheckerXSmallBoldIcon',
  12
);
export const ProxyCheckerSmallIcon = createIcon(
  ProxyCheckerSmallIconSvg,
  'ProxyCheckerSmallIcon',
  16
);
export const ProxyCheckerSmallBoldIcon = createIcon(
  ProxyCheckerSmallBoldIconSvg,
  'ProxyCheckerSmallBoldIcon',
  16
);
export const ProxyCheckerMediumIcon = createIcon(
  ProxyCheckerMediumIconSvg,
  'ProxyCheckerMediumIcon',
  20
);
export const ProxyCheckerMediumBoldIcon = createIcon(
  ProxyCheckerMediumBoldIconSvg,
  'ProxyCheckerMediumBoldIcon',
  20
);
export const ProxyCheckerLargeIcon = createIcon(
  ProxyCheckerLargeIconSvg,
  'ProxyCheckerLargeIcon',
  24
);
export const ProxyCheckerLargeBoldIcon = createIcon(
  ProxyCheckerLargeBoldIconSvg,
  'ProxyCheckerLargeBoldIcon',
  24
);
export const ECommerceXSmallIcon = createIcon(
  ECommerceXSmallIconSvg,
  'ECommerceXSmallIcon',
  12
);
export const ECommerceXSmallBoldIcon = createIcon(
  ECommerceXSmallBoldIconSvg,
  'ECommerceXSmallBoldIcon',
  12
);
export const ECommerceSmallIcon = createIcon(
  ECommerceSmallIconSvg,
  'ECommerceSmallIcon',
  16
);
export const ECommerceSmallBoldIcon = createIcon(
  ECommerceSmallBoldIconSvg,
  'ECommerceSmallBoldIcon',
  16
);
export const ECommerceMediumIcon = createIcon(
  ECommerceMediumIconSvg,
  'ECommerceMediumIcon',
  20
);
export const ECommerceMediumBoldIcon = createIcon(
  ECommerceMediumBoldIconSvg,
  'ECommerceMediumBoldIcon',
  20
);
export const ECommerceLargeIcon = createIcon(
  ECommerceLargeIconSvg,
  'ECommerceLargeIcon',
  24
);
export const ECommerceLargeBoldIcon = createIcon(
  ECommerceLargeBoldIconSvg,
  'ECommerceLargeBoldIcon',
  24
);
export const SiteUnblockerXSmallIcon = createIcon(
  SiteUnblockerXSmallIconSvg,
  'SiteUnblockerXSmallIcon',
  12
);
export const SiteUnblockerXSmallBoldIcon = createIcon(
  SiteUnblockerXSmallBoldIconSvg,
  'SiteUnblockerXSmallBoldIcon',
  12
);
export const SiteUnblockerSmallIcon = createIcon(
  SiteUnblockerSmallIconSvg,
  'SiteUnblockerSmallIcon',
  16
);
export const SiteUnblockerSmallBoldIcon = createIcon(
  SiteUnblockerSmallBoldIconSvg,
  'SiteUnblockerSmallBoldIcon',
  16
);
export const SiteUnblockerMediumIcon = createIcon(
  SiteUnblockerMediumIconSvg,
  'SiteUnblockerMediumIcon',
  20
);
export const SiteUnblockerMediumBoldIcon = createIcon(
  SiteUnblockerMediumBoldIconSvg,
  'SiteUnblockerMediumBoldIcon',
  20
);
export const SiteUnblockerLargeIcon = createIcon(
  SiteUnblockerLargeIconSvg,
  'SiteUnblockerLargeIcon',
  24
);
export const SiteUnblockerLargeBoldIcon = createIcon(
  SiteUnblockerLargeBoldIconSvg,
  'SiteUnblockerLargeBoldIcon',
  24
);
export const SERPXSmallIcon = createIcon(
  SERPXSmallIconSvg,
  'SERPXSmallIcon',
  12
);
export const SERPXSmallBoldIcon = createIcon(
  SERPXSmallBoldIconSvg,
  'SERPXSmallBoldIcon',
  12
);
export const SERPSmallIcon = createIcon(SERPSmallIconSvg, 'SERPSmallIcon', 16);
export const SERPSmallBoldIcon = createIcon(
  SERPSmallBoldIconSvg,
  'SERPSmallBoldIcon',
  16
);
export const SERPMediumIcon = createIcon(
  SERPMediumIconSvg,
  'SERPMediumIcon',
  20
);
export const SERPMediumBoldIcon = createIcon(
  SERPMediumBoldIconSvg,
  'SERPMediumBoldIcon',
  20
);
export const SERPLargeIcon = createIcon(SERPLargeIconSvg, 'SERPLargeIcon', 24);
export const SERPLargeBoldIcon = createIcon(
  SERPLargeBoldIconSvg,
  'SERPLargeBoldIcon',
  24
);
export const ScrapersXSmallIcon = createIcon(
  ScrapersXSmallIconSvg,
  'ScrapersXSmallIcon',
  12
);
export const ScrapersXSmallBoldIcon = createIcon(
  ScrapersXSmallBoldIconSvg,
  'ScrapersXSmallBoldIcon',
  12
);
export const ScrapersSmallIcon = createIcon(
  ScrapersSmallIconSvg,
  'ScrapersSmallIcon',
  16
);
export const ScrapersSmallBoldIcon = createIcon(
  ScrapersSmallBoldIconSvg,
  'ScrapersSmallBoldIcon',
  16
);
export const ScrapersMediumIcon = createIcon(
  ScrapersMediumIconSvg,
  'ScrapersMediumIcon',
  20
);
export const ScrapersMediumBoldIcon = createIcon(
  ScrapersMediumBoldIconSvg,
  'ScrapersMediumBoldIcon',
  20
);
export const ScrapersLargeIcon = createIcon(
  ScrapersLargeIconSvg,
  'ScrapersLargeIcon',
  24
);
export const ScrapersLargeBoldIcon = createIcon(
  ScrapersLargeBoldIconSvg,
  'ScrapersLargeBoldIcon',
  24
);
export const ProxiesXSmallIcon = createIcon(
  ProxiesXSmallIconSvg,
  'ProxiesXSmallIcon',
  12
);
export const ProxiesXSmallBoldIcon = createIcon(
  ProxiesXSmallBoldIconSvg,
  'ProxiesXSmallBoldIcon',
  12
);
export const ProxiesSmallIcon = createIcon(
  ProxiesSmallIconSvg,
  'ProxiesSmallIcon',
  16
);
export const ProxiesSmallBoldIcon = createIcon(
  ProxiesSmallBoldIconSvg,
  'ProxiesSmallBoldIcon',
  16
);
export const ProxiesMediumIcon = createIcon(
  ProxiesMediumIconSvg,
  'ProxiesMediumIcon',
  20
);
export const ProxiesMediumBoldIcon = createIcon(
  ProxiesMediumBoldIconSvg,
  'ProxiesMediumBoldIcon',
  20
);
export const ProxiesLargeIcon = createIcon(
  ProxiesLargeIconSvg,
  'ProxiesLargeIcon',
  24
);
export const ProxiesLargeBoldIcon = createIcon(
  ProxiesLargeBoldIconSvg,
  'ProxiesLargeBoldIcon',
  24
);
